import InputCustom from "@pages/components/InputCustom";
import { InputKeySelect } from "@pages/components/InputSelect";
import {ButtonContainer, Line } from "@pages/reusable-components/styled-components";
import React, {useEffect, useState} from "react";
import {Card, CardBody, CardHeader, Carousel, CarouselControl, CarouselItem, Col, Modal, Row} from "reactstrap";
import axios from "axios";
import { API_URL } from "@constants/index";
import notify from "@utils/notify";
import {Simulate} from "react-dom/test-utils";
import load = Simulate.load;
interface VehicleFrontEndProps {
    initialVehicle: any,
    errors: any,
    paymentIntervals: any,
    updateVehicleAdministrative: (vehicle?: any) => void;
    delay: any,
    id: number | string,
    initialSlides: any,
}
const VehicleFrontEnd:React.FC<VehicleFrontEndProps> = ({
                                                            initialVehicle, errors,
                                                            paymentIntervals, updateVehicleAdministrative,
                                                            id, initialSlides, delay
                                                        }) => {

    const [vehicle, setVehicle] = useState<any>(null);
    const [slides, setSlides] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        if (initialVehicle && Object.keys(initialVehicle).length) {
            console.log('2222',initialVehicle)
            setVehicle(initialVehicle);
            if (loading) {
                setLoading(false)
            }
        }
    }, [initialVehicle]);

    useEffect(()=>{
        if (initialSlides && Object.keys(initialSlides).length) {
            setSlides(initialSlides);
            if (loading) {
                setLoading(false)
            }
        }
    },[initialSlides])

    const [vehicleImages, setVehicleImages] = useState<any>({})
    const [confirmModal, setConfirmModal] = useState(false)
    const [animating, setAnimating] = useState(false)
    const [selectedImage, setSelectedImage] = useState({
        id: '',
        index: ''
    })
    const [activeIndex, setActiveIndex] = useState(0)
    const deleteImage = () => {
        axios({
            method: 'DELETE',
            url: `${API_URL}/vehicle/${id}/remove/${selectedImage.id}`,

        }).then(response => {
                setConfirmModal(false)
                console.log('response :: ', response.data)
                const data = response.data
                if (vehicleImages.images_collection) {

                    const collection_images = vehicleImages.images_collection
                    let _new_1 = []
                    let _new_2 = []
                    let new_collection_images = []

                    _new_1 = collection_images.slice(0, selectedImage.index)
                    _new_2 = collection_images.slice(selectedImage.index + 1, collection_images.length)
                    new_collection_images = _new_1.concat(_new_2)

                    const slides = new_collection_images.map((item) => {
                        return (
                            <CarouselItem
                                onExiting={() => setAnimating(true)}
                                onExited={() => setAnimating(false)}
                                key={item.link}
                            >
                                <img alt={''} src={`${item.link}`} width={900} height={405} />
                            </CarouselItem>
                        )
                    })
                    setSlides(slides)
                    setVehicleImages({
                        ...vehicleImages,
                        images_collection: new_collection_images,
                    })
                }
                notify.success(data.message)
            })
            .catch(error => {
                setConfirmModal(false)
                console.error('error :: ', error)
                notify.warning(error.response ? error.response.statusText : 'Error occurred!')
            })
    }

    const next = (items) => {
        if (animating) return
        if (items.length > 0) {
            const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1
            setActiveIndex(nextIndex)
        }
    }

    const previous = (items) => {
        if (animating) return
        if (items.length > 0) {
            const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1
            setActiveIndex(nextIndex)
        }
    }

    const goToIndex = (newIndex) => {
        if (animating) return
        setActiveIndex(newIndex)
    }

    async function uploadVehicleImage() {
        if (!vehicle.featured_image) {
            console.error('No image to upload');
            return;
        }

        const formData = new FormData();
        formData.append('featured_image', vehicle.featured_image);
        try {
            const response = await axios.post(`${API_URL}/vehicle/${id}/image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log('Upload successful', response.data);
            // Handle success response
        } catch (error) {
            console.error('Upload failed', error);
            // Handle error
        }
    }

    return (  !loading &&
        <CardBody>
            <Modal
                isOpen={confirmModal}
                toggle={() => setConfirmModal(false)}
                className="modal-dialog-centered"
            >
                <div className="modal-header main-color">
                    <h6 className="modal-title">{`Delete Image`}</h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setConfirmModal(false)}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body ">
                    {`Are you sure you want to delete this image?`}
                </div>
                <div className="modal-footer justify-content-end">

                    <ButtonContainer
                        onClick={() => setConfirmModal(false)}
                    >
                        {`Close`}
                    </ButtonContainer>
                    <ButtonContainer
                        reverse
                        onClick={() => deleteImage()}
                    >
                        {`Delete`}
                    </ButtonContainer>
                </div>
            </Modal>
            <Card>
                <CardHeader>
                    <h2>Financial details available for front end ( customer section )</h2>
                </CardHeader>
                <CardHeader>
                    <Row>
                        <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                        <span
                            style={{ color: vehicle && vehicle.vehicle_division === 0 && '#ec6409', margin: 5 }}
                            onClick={() => setVehicle({
                                ...vehicle,
                                vehicle_division: 0
                            })}>
                          Rental Deal
                        </span>
                            {vehicle && vehicle.vehicle_division === 0 &&
                                <Line color={'#ec6409'} />
                            }
                        </div>
                        <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                        <span
                            style={{ color: vehicle && vehicle.vehicle_division === 1 && '#ec6409', margin: 5 }}
                            onClick={() => setVehicle({
                                ...vehicle,
                                vehicle_division: 1
                            })}>
                          Purchase Deal
                        </span>
                            {vehicle && vehicle.vehicle_division === 1 &&
                                <Line color={'#ec6409'} />
                            }
                        </div>
                    </Row>

                </CardHeader>
                <CardBody>
                    {vehicle && vehicle.vehicle_division === 0 &&
                        <>
                            <Row>
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        type={`number`}
                                        newLabel={`Estimated Price`}
                                        value={vehicle && vehicle.administrative?.estimated_term_price ? vehicle.administrative?.estimated_term_price : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    estimated_term_price: target,
                                                },
                                            }));
                                        }}
                                        invalid={errors && errors.estimated_term_price ? true : false}
                                        errorMessage={errors.estimated_term_price}
                                    />
                                </Col>
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        type={`text`}
                                        newLabel={`Admin fee`}
                                        value={vehicle && vehicle.administrative?.admin_fee ? vehicle.administrative?.admin_fee : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    admin_fee: target,
                                                },
                                            }));
                                        }}
                                        invalid={errors && errors.admin_fee ? true : false}
                                        errorMessage={errors.admin_fee}
                                    />
                                </Col>
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        type={`text`}
                                        newLabel={`Total Upfront Fee`}
                                        value={vehicle && vehicle.administrative?.total_upfront_fee ? vehicle.administrative?.total_upfront_fee : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    total_upfront_fee: target,
                                                },
                                            }));
                                        }}
                                        invalid={errors && errors.total_upfront_fee ? true : false}
                                        errorMessage={errors.total_upfront_fee}
                                    />
                                </Col>
                                <Col md={4} sm={12}>
                                      <InputKeySelect
                                        newLabel={`Vehicle Age`}
                                        value={vehicle && vehicle.administrative?.vehicle_age ? vehicle.administrative.vehicle_age : ''}
                                        options={{new: 'New', used: 'Used'}}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    vehicle_age: target,
                                                },
                                            }));
                                        }}
                                        defaultOption={true}
                                        invalid={errors && errors.vehicle_age ? true : false}
                                        errorMessage={errors.vehicle_age}
                                    />
                                </Col>
                               {/* <Col md={4} sm={12}>
                                     <InputCustom
                                        type={`number`}
                                        newLabel={`Estimated Term`}
                                        value={vehicle && vehicle.administrative?.estimated_term ? vehicle.administrative?.estimated_term : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    estimated_term: target,
                                                },
                                            }));
                                        }}
                                        invalid={errors && errors.estimated_term ? true : false}
                                        errorMessage={errors.estimated_term}
                                    /> 
                                </Col> */}
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        type={`number`}
                                        newLabel={`Initial Payment`}
                                        value={vehicle && vehicle.administrative?.estimated_initial_payment ? vehicle.administrative.estimated_initial_payment : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    estimated_initial_payment: target,
                                                },
                                            }));
                                        }}
                                        invalid={errors && errors.estimated_initial_payment ? true : false}
                                        errorMessage={errors.estimated_initial_payment}
                                    />
                                </Col>
                                {/* <Col md={4} sm={12}>
                                    <InputKeySelect
                                        newLabel={`Interval`}
                                        value={vehicle && vehicle.administrative?.estimated_term_interval ? vehicle.administrative.estimated_term_interval : ''}
                                        options={paymentIntervals}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    estimated_term_interval: target,
                                                },
                                            }));
                                        }}
                                        defaultOption={true}
                                        invalid={errors && errors.estimated_term_interval ? true : false}
                                        errorMessage={errors.estimated_term_interval}
                                    />
                                </Col> */}
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        type={`number`}
                                        newLabel={`28 days mileage`}
                                        value={vehicle && vehicle.administrative?.annual_mileage ? vehicle.administrative.annual_mileage : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    annual_mileage: target,
                                                },
                                            }));
                                        }}
                                        defaultOption={true}
                                        invalid={errors && errors.annual_mileage ? true : false}
                                        errorMessage={errors.annual_mileage}
                                    />
                                </Col>
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        newLabel={`Add Text`}
                                        value={vehicle && vehicle.administrative?.custom_text ? vehicle.administrative.custom_text : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    custom_text: target,
                                                },
                                            }));
                                        }}
                                        defaultOption={true}
                                        invalid={errors && errors.custom_text ? true : false}
                                        errorMessage={errors.custom_text}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} sm={12}>
                                    <InputCustom
                                        type={`textarea`}
                                        newLabel={`Description`}
                                        value={vehicle && vehicle.administrative?.description ? vehicle.administrative.description : ''}
                                        onChange={e => {
                                            const target = e.target.value;
                                            setVehicle(prevVehicle => ({
                                                ...prevVehicle,
                                                administrative: {
                                                    ...prevVehicle.administrative,
                                                    description: target,
                                                },
                                            }));
                                        }}
                                        defaultOption={true}
                                        invalid={errors && errors.description ? true : false}
                                        errorMessage={errors.description}
                                    />
                                </Col>
                            </Row>
                        </>

                    }
                    {vehicle && vehicle.vehicle_division === 1 &&
                        <Row>
                            <Col md={3} sm={12}>
                                <InputCustom
                                    type={`number`}
                                    newLabel={`Purchase Price`}
                                    value={vehicle && vehicle.administrative?.purchase_price ? vehicle.administrative?.purchase_price : ''}
                                    onChange={e => {
                                        const target = e.target.value;
                                        setVehicle(prevVehicle => ({
                                            ...prevVehicle,
                                            administrative: {
                                                ...prevVehicle.administrative,
                                                purchase_price: target,
                                            },
                                        }));
                                    }}
                                    invalid={errors && errors.purchase_price ? true : false}
                                    errorMessage={errors.purchase_price}
                                />
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md={12}>
                            <ButtonContainer reverse onClick={() => updateVehicleAdministrative(vehicle)}>Save</ButtonContainer>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Card>
                <CardHeader>
                    <h2>Image Upload</h2>
                </CardHeader>
                <CardBody>
                    <div className="custom-file">
                        <input
                            className="custom-file-input profile-file-input"
                            id="featured_image"
                            lang="en"
                            type="file"
                            onChange={e => setVehicle({
                                ...vehicle,
                                featured_image: e.target.files[0]
                            })}
                        />
                        <label
                            className="custom-file-label"
                            htmlFor="customFileLang"
                        >
                            Featured image
                        </label>
                    </div>
                    <div className="custom-file mt-3">
                        <input
                            className="custom-file-input profile-file-input"
                            id="images_collection"
                            lang="en"
                            type="file"
                            multiple
                            onChange={e => setVehicle({
                                ...vehicle,
                                images_collection: e.target.files
                            })}
                        />
                        <label
                            className="custom-file-label"
                            htmlFor="customFileLang"
                        >
                            Images collection
                        </label>
                    </div>
                    <Row className="mt-3">
                        <Col md={12}>
                            <ButtonContainer reverse onClick={() => uploadVehicleImage()}>Save</ButtonContainer>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={12}>
                            <h2>Vehicle uploaded photos</h2>
                        </Col>
                    </Row>
                    <CardBody>
                        {vehicleImages?.featured_image && <Row>
                            <Col md={12}>
                                <h2 className="text-center mb-3">Featured image</h2>
                                <div className="col-lg-8 offset-lg-2">
                                    <img alt={''} src={`${vehicleImages.featured_image}`} className="img-fluid" />
                                </div>
                            </Col>
                        </Row>}
                        {delay && vehicleImages?.images_collection && vehicleImages?.images_collection.length > 0 && <Row className="justify-content-md-center">
                            <Col md={7}>
                                <h2 className="text-center my-4">Images collection</h2>
                                <Carousel
                                    activeIndex={activeIndex}
                                    next={() => next(vehicleImages.images_collection)}
                                    previous={() => previous(vehicleImages.images_collection)}
                                >
                                    {
                                        slides
                                    }
                                    <CarouselControl direction="prev" directionText="Previous" onClickHandler={() => previous(vehicleImages.images_collection)} />
                                    <CarouselControl direction="next" directionText="Next" onClickHandler={() => next(vehicleImages.images_collection)} />

                                </Carousel>
                                <ol
                                    className="carousel-indicators"
                                    style={{
                                        position: 'relative',
                                        width: '100%',
                                        margin: 0,
                                        overflowX: 'scroll',
                                        display: '-webkit-box',
                                    }}>
                                    {vehicleImages?.images_collection.map((item, index) => {
                                        return (
                                            <li
                                                key={index}
                                                className={`${activeIndex === index ? 'active' : ''}`}
                                                style={{
                                                    position: 'relative',
                                                    width: 220,
                                                    height: 130,
                                                    textIndent: 0,
                                                }}
                                            >
                                                <img
                                                    alt={''}
                                                    src={`${item.link}`}
                                                    width={220}
                                                    height={100}
                                                    onClick={() => goToIndex(index)}
                                                />
                                                <span className="text-center carousel-trash">
                                    <i className="fas fa-trash text-danger" onClick={() => {
                                        setSelectedImage({
                                            ...selectedImage,
                                            id: item._id,
                                            index: index,
                                        })
                                        setConfirmModal(true)
                                    }} />
                                  </span>
                                            </li>
                                        );
                                    })}
                                </ol>
                            </Col>
                        </Row>}
                    </CardBody>
                </CardBody>
            </Card>
        </CardBody>
    )
}
export default VehicleFrontEnd;